module.exports = __webpack_public_path__ + "img/character03.a7e7bc2f.png";